import { MdArrowBack, MdEmail, MdPersonPin, MdPhone } from "react-icons/md";
import PropTypes from "prop-types";

// Composants
const DoctorDetails = ({ doctor, onClose, getPhotoUrl }) => {
  return (
    <div className="space-y-6">
      {/* En-tête */}
      <div className="flex justify-between border-b border-gray-200 pb-4">
        <h2 className="text-2xl font-bold text-gray-800">
          {doctor.titre} {doctor.name}
        </h2>
        <button
          onClick={onClose}
          className="rounded-md border border-gray-300 px-3 py-1 text-sm transition-colors hover:bg-gray-100"
        >
          <MdArrowBack className="mr-1 inline" /> Retour
        </button>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {/* Photo */}
        <div className="flex flex-col items-center justify-center">
          {doctor.photo ? (
            <div className="h-64 w-64 overflow-hidden rounded-lg border border-gray-200 shadow-md">
              <img
                src={getPhotoUrl(doctor.photo)}
                alt={doctor.name}
                className="h-full w-full object-cover"
              />
            </div>
          ) : (
            <div className="flex h-64 w-64 items-center justify-center rounded-lg bg-gradient-to-br from-[#2ca01c]/10 to-[#7028a9]/10">
              <MdPersonPin className="text-9xl text-[#2ca01c]/30" />
            </div>
          )}
          <span className="mt-3 inline-block rounded-md bg-blue-100 px-3 py-1 text-sm font-medium text-blue-800">
            {doctor.specialization}
          </span>
        </div>

        {/* Informations du médecin */}
        <div className="space-y-6">
          <div>
            <h3 className="mb-2 text-lg font-medium text-gray-700">
              Coordonnées
            </h3>
            <div className="rounded-lg bg-gray-50 p-4">
              <div className="mb-3 flex items-start">
                <MdEmail className="mr-3 mt-1 text-xl text-[#2ca01c]" />
                <div>
                  <p className="text-sm font-medium text-gray-500">Email</p>
                  <p className="text-gray-800">{doctor.email}</p>
                </div>
              </div>
              <div className="flex items-start">
                <MdPhone className="mr-3 mt-1 text-xl text-[#2ca01c]" />
                <div>
                  <p className="text-sm font-medium text-gray-500">Téléphone</p>
                  <p className="text-gray-800">{doctor.phone}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="rounded-lg border border-gray-200 p-4">
            <h3 className="mb-3 text-lg font-medium text-gray-700">
              Informations
            </h3>
            <div className="space-y-2">
              <div className="flex">
                <span className="w-28 font-medium text-gray-500">Titre:</span>
                <span className="text-gray-800">{doctor.titre}</span>
              </div>
              <div className="flex">
                <span className="w-28 font-medium text-gray-500">Nom:</span>
                <span className="text-gray-800">{doctor.name}</span>
              </div>
              <div className="flex">
                <span className="w-28 font-medium text-gray-500">
                  Spécialité:
                </span>
                <span className="text-gray-800">{doctor.specialization}</span>
              </div>
              <div className="flex">
                <span className="w-28 font-medium text-gray-500">
                  Identifiant:
                </span>
                <span className="text-gray-800">{doctor.id}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
DoctorDetails.propTypes = {
  doctor: PropTypes.shape({
    titre: PropTypes.string,
    name: PropTypes.string,
    photo: PropTypes.string,
    specialization: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  getPhotoUrl: PropTypes.func.isRequired,
};

export default DoctorDetails;
